import React from 'react';
import { withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Popover, PopoverBody } from 'reactstrap';
import { writeErr } from '../common/logger';
import { apiGet, apiPost, getHostApi } from '../../store/apiWrapper';

class AlertNotePreview extends React.Component {
    static defaultProps = {
        placement: "left"
    };

    _noConflictPopover = undefined;
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            note: '',
            showPreview: false,
            noteId: this.props.noteId,
            error: ''
        };
    }

    toggle(value) {
        this.setState({ showPreview: value });
    }

    render() {
        if (isNullOrUndefined(this.state.noteId))
            return null;

        return (<React.Fragment>
                    {React.cloneElement(this.props.children, { onMouseEnter: () => this.getPreview(), onMouseOver: () => this.toggle(true), onMouseOut: () => this.toggle(false),  onMouseLeave: () => this.toggle(false) })}
                    {this.renderPreview()}
               </React.Fragment>)
    }


    renderPreview = () => {
        return (<>
            <Popover placement={this.props.placement} isOpen={this.state.showPreview} toggle={() => this.toggle(!this.state.showPreview)} target={this.props.targetId}>
                <PopoverBody>
                    {this.state.error ? this.props.translate(this.state.error) : this.state.note.length > 250 ? this.state.note.substring(0,250) + '...' : this.state.note}
                </PopoverBody>
            </Popover>
        </>)
    }

    getPreview = () => {
        this.setState({ showPreview: true });
        apiGet(`${getHostApi()}/api/portfolio/notes/${this.props.noteId}`, null,
            (s) => {
                this.setState({
                    note: s.data.note ? s.data.note.replace(/(<(\/p)>)/g, " ").replace(/(<([^>]+)>)/gi, "").replace(/\s\s+/g, ' ') : '',
                    error: s.data.error
                });
                },
                (e) => writeErr(e)
            );
    }
}

export default withLocalize(AlertNotePreview);